// Ayarlar → Profil → Hesabı / çalışma alanını kalıcı silme (KVKK silme hakkı). Backend: POST /auth/me/delete, POST /clients/{id}/delete-workspace
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { T, MONO } from './poyais-ui/theme';
import { useLang, addTranslations } from './i18n';

addTranslations({
  'Tehlikeli bölge': 'Danger zone',
  'Hesabı sil': 'Delete account',
  'Hesabınız ve kişisel verileriniz hemen ve kalıcı olarak silinir; geri alınamaz. Yasal saklama yükümlülüğü olan ödeme ve fatura kayıtları dışında hiçbir veri tutulmaz. Tek üyesi olduğunuz çalışma alanları da silinir.': 'Your account and personal data are deleted immediately and permanently; this cannot be undone. Nothing is kept except payment and invoice records we are legally required to retain. Workspaces where you are the only member are deleted too.',
  'Şifre': 'Password',
  'Doğrulama kodu': 'Verification code',
  'Hesabımı kalıcı olarak sil': 'Permanently delete my account',
  'Vazgeç': 'Cancel',
  'Çalışma alanını sil': 'Delete workspace',
  'Çalışma alanı ve içindeki tüm veri (bağlı platform anahtarları, görevler, notlar, raporlar, hafıza…) kalıcı olarak silinir. Aktif bir abonelik varsa önce Faturalandırma\'dan iptal etmeniz gerekir. Yalnızca çalışma alanı yöneticisi silebilir.': 'The workspace and all of its data (connected platform keys, tasks, notes, reports, memory…) are permanently deleted. If there is an active subscription you must cancel it under Billing first. Only the workspace admin can delete it.',
  'Onaylamak için çalışma alanı adını yazın': 'Type the workspace name to confirm',
  'Çalışma alanını kalıcı olarak sil': 'Permanently delete workspace',
  'Bir hata oluştu, tekrar dener misin?': 'Something went wrong, please try again.',
});

const label: React.CSSProperties = { fontSize: 9, fontWeight: 700, color: T.accent, letterSpacing: '0.1em', textTransform: 'uppercase', fontFamily: 'Manrope, sans-serif', marginBottom: 6 };
const input: React.CSSProperties = { width: '100%', padding: '10px 12px', borderRadius: 8, border: `1px solid ${T.borderMid}`, fontSize: 14, fontFamily: 'Manrope, sans-serif', background: T.subtleBg, outline: 'none', color: T.text, boxSizing: 'border-box' };
const ghost: React.CSSProperties = { padding: '9px 16px', borderRadius: 11, border: `1px solid ${T.borderMid}`, background: T.surface, color: T.text, fontSize: 13, fontWeight: 700, cursor: 'pointer', fontFamily: 'Manrope, sans-serif' };
const danger: React.CSSProperties = { padding: '9px 16px', borderRadius: 11, border: 'none', background: T.redText, color: '#fff', fontSize: 13, fontWeight: 700, cursor: 'pointer', fontFamily: 'Manrope, sans-serif' };

export default function DangerZoneCard({ workspace }: { workspace?: { id: number; name: string } | null }) {
  const { t } = useLang();
  const [mfa, setMfa] = useState(false);
  const [open, setOpen] = useState<'' | 'account' | 'workspace'>('');
  const [pw, setPw] = useState('');
  const [code, setCode] = useState('');
  const [name, setName] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');

  useEffect(() => { axios.get('/api/v1/auth/2fa/status').then(r => setMfa(!!r.data.enabled)).catch(() => {}); }, []);

  const fail = (e: any) => setErr(e?.response?.data?.detail || t('Bir hata oluştu, tekrar dener misin?'));
  const reset = () => { setOpen(''); setPw(''); setCode(''); setName(''); setErr(''); };

  const delAccount = async () => {
    setBusy(true); setErr('');
    try {
      await axios.post('/api/v1/auth/me/delete', { password: pw, code });
      localStorage.removeItem('poyais_token'); localStorage.removeItem('poyais_user');
      window.location.href = '/';
    } catch (e) { fail(e); setBusy(false); }
  };
  const delWorkspace = async () => {
    if (!workspace) return;
    setBusy(true); setErr('');
    try {
      await axios.post(`/api/v1/clients/${workspace.id}/delete-workspace`, { confirm_name: name });
      window.location.href = '/';
    } catch (e) { fail(e); setBusy(false); }
  };

  const box: React.CSSProperties = { border: `1px solid ${T.redTint}`, borderRadius: 12, padding: 16, marginTop: 14, background: T.surface };
  return (
    <div style={{ background: T.surface, borderRadius: 16, border: `1px solid ${T.border}`, padding: '22px 24px' }}>
      <div style={{ fontSize: 9, fontWeight: 700, color: T.redText, letterSpacing: '0.15em', textTransform: 'uppercase', fontFamily: 'Manrope, sans-serif', marginBottom: 4 }}>{t('Tehlikeli bölge')}</div>

      {workspace && (
        <div style={{ marginBottom: 22 }}>
          <div style={{ fontSize: 18, fontWeight: 700, color: T.text, marginBottom: 6 }}>{t('Çalışma alanını sil')}</div>
          <div style={{ fontSize: 13, color: T.textMidAlt, lineHeight: 1.6, maxWidth: 640 }}>
            {t("Çalışma alanı ve içindeki tüm veri (bağlı platform anahtarları, görevler, notlar, raporlar, hafıza…) kalıcı olarak silinir. Aktif bir abonelik varsa önce Faturalandırma'dan iptal etmeniz gerekir. Yalnızca çalışma alanı yöneticisi silebilir.")}
          </div>
          {open !== 'workspace' ? (
            <button onClick={() => { reset(); setOpen('workspace'); }} style={{ ...ghost, marginTop: 12, color: T.redText, borderColor: T.redTint }}>{t('Çalışma alanını sil')}</button>
          ) : (
            <div style={box}>
              <div style={label}>{t('Onaylamak için çalışma alanı adını yazın')}: <span style={{ fontFamily: MONO, textTransform: 'none', letterSpacing: 0, color: T.text }}>{workspace.name}</span></div>
              <input value={name} onChange={e => setName(e.target.value)} style={{ ...input, marginBottom: 12 }} />
              {err && <div style={{ fontSize: 12, color: T.redText, marginBottom: 10 }}>{err}</div>}
              <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                <button onClick={delWorkspace} disabled={busy || name.trim() !== workspace.name.trim()} style={{ ...danger, opacity: name.trim() === workspace.name.trim() ? 1 : 0.5 }}>{t('Çalışma alanını kalıcı olarak sil')}</button>
                <button onClick={reset} style={ghost}>{t('Vazgeç')}</button>
              </div>
            </div>
          )}
        </div>
      )}

      <div>
        <div style={{ fontSize: 18, fontWeight: 700, color: T.text, marginBottom: 6 }}>{t('Hesabı sil')}</div>
        <div style={{ fontSize: 13, color: T.textMidAlt, lineHeight: 1.6, maxWidth: 640 }}>
          {t('Hesabınız ve kişisel verileriniz hemen ve kalıcı olarak silinir; geri alınamaz. Yasal saklama yükümlülüğü olan ödeme ve fatura kayıtları dışında hiçbir veri tutulmaz. Tek üyesi olduğunuz çalışma alanları da silinir.')}
        </div>
        {open !== 'account' ? (
          <button onClick={() => { reset(); setOpen('account'); }} style={{ ...ghost, marginTop: 12, color: T.redText, borderColor: T.redTint }}>{t('Hesabı sil')}</button>
        ) : (
          <div style={box}>
            <div style={label}>{t('Şifre')}</div>
            <input type="password" autoComplete="current-password" value={pw} onChange={e => setPw(e.target.value)} style={{ ...input, marginBottom: 12 }} />
            {mfa && (<>
              <div style={label}>{t('Doğrulama kodu')}</div>
              <input value={code} onChange={e => setCode(e.target.value)} autoComplete="one-time-code" style={{ ...input, marginBottom: 12, fontFamily: MONO }} />
            </>)}
            {err && <div style={{ fontSize: 12, color: T.redText, marginBottom: 10 }}>{err}</div>}
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
              <button onClick={delAccount} disabled={busy || !pw || (mfa && !code.trim())} style={{ ...danger, opacity: pw && (!mfa || code.trim()) ? 1 : 0.5 }}>{t('Hesabımı kalıcı olarak sil')}</button>
              <button onClick={reset} style={ghost}>{t('Vazgeç')}</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
